import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FeatureBreadcrumbsModule } from '@auto-editor/feature-breadcrumbs';
import { SharedComponentsModule } from '@auto-editor/shared/components';
import { TranslateModule } from '@ngx-translate/core';
import { EditInputComponent } from './edit-input/edit-input.component';
import { ToolbarComponent } from './ui-toolbar/toolbar.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatTooltipModule,
    FeatureBreadcrumbsModule,
    MatMenuModule,
    MatIconModule,
    MatSelectModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    MatButtonModule,
    SharedComponentsModule,
    TranslateModule
  ],
  exports: [ToolbarComponent],
  declarations: [ToolbarComponent, EditInputComponent]
})
export class CoreLayoutFeatureHeaderModule {}
